/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from 'perfect-scrollbar';
import { NavLink, useNavigate } from 'react-router-dom';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { getAllowedRoutes, checkMenuItemConditions, buildLoginPath } from '../../utils';

// @mui/material components
import {
    Drawer,
    List,
    ListItem,
    ListItemText,
    Hidden,
    Collapse,
    Icon,
    Tooltip,
    Popover,
} from '@mui/material';
import { Edit, ChevronLeft, ChevronRight, Close, ExpandMore } from '@mui/icons-material';

import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import ThemeToggle from '../ThemeToggle/ThemeToggle';
import LogoutButton from '../LogoutButton/LogoutButton';
import { clearLocalStoragePreservingPrefs } from '../../utils/clearLocalStoragePreservingPrefs';

// core components
import AdminNavbarLinks from '../Navbars/AdminNavbarLinks.js';
import sidebarStyle from '../../assets/jss/material-dashboard-pro-react/components/sidebarStyle.js';
import avatar from '../../assets/img/default-avatar.png';
import styles from './Sidebar.module.scss';
import logo_mini from '../../assets/img/logo_spara_transparent.png';
import { createUseStyles } from 'react-jss';
import Bugsnag from '@bugsnag/js';
import useSWR from 'swr';
import { authApi, fetcher } from '../../lib/api';
var ps;

const useStyles = createUseStyles(sidebarStyle);

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {
    sidebarWrapper = React.createRef();

    componentDidMount() {
        if (navigator.platform.indexOf('Win') > -1) {
            ps = new PerfectScrollbar(this.sidebarWrapper.current, {
                suppressScrollX: true,
                suppressScrollY: false,
            });
        }
    }

    componentWillUnmount() {
        if (navigator.platform.indexOf('Win') > -1) {
            ps.destroy();
        }
    }

    render() {
        const { className, user, headerLinks, links } = this.props;
        return (
            <div className={className} ref={this.sidebarWrapper}>
                {user}
                {headerLinks}
                {links}
            </div>
        );
    }
}

// this creates the intial state of this component based on the collapse routes
// that it gets through this.props.routes
const getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop) => {
        if (prop.collapse) {
            initialState = {
                [prop.state]: getCollapseInitialState(prop.views, prop),
                ...getCollapseStates(prop.views),
                ...initialState,
            };
        }
        return null;
    });
    return initialState;
};

// this verifies if any of the collapses should be default opened on a rerender of this component
// for example, on the refresh of the page,
// while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
// fyrir defaultOpen stuðning
const getCollapseInitialState = (routes, parentProp) => {
    // Ef parentProp er með defaultOpen, skila true
    if (parentProp && parentProp.defaultOpen) {
        return true;
    }
    for (let i = 0; i < routes.length; i++) {
        if (routes[i].open) {
            return true;
        }
        if (routes[i].collapse && getCollapseInitialState(routes[i].views, routes[i])) {
            return true;
        } else if (window.location.href.indexOf(routes[i].path) !== -1) {
            return true;
        }
    }
    return false;
};

const SideBar = (props) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { routes, bgColor, color, t, loggingOut, onLogoutStart, sidebarMinimize } = props;
    const [openAvatar, setOpenAvatar] = useState(false);
    const [miniActive, setMiniActive] = useState(props.miniActive);
    const [collapseState, setCollapseState] = useState(getCollapseStates(props.routes));
    const mainPanel = React.createRef();


    useEffect(() => {
        setMiniActive(props.miniActive);
    }, [props.miniActive]);

    const store = JSON.parse(localStorage.getItem('user'));

    if (!store) {
        clearLocalStoragePreservingPrefs();
        window.location.href = buildLoginPath();
        return null;
    }

    const { data: liveUserData } = useSWR(
        authApi.me,
        fetcher,
        { revalidateOnFocus: false }
    );

    const [companiesAnchor, setCompaniesAnchor] = useState(null);
    const [groupsAnchor, setGroupsAnchor] = useState(null);

    const userPermission = store.permission;
    const userGroupTypes = store.groupTypes;

    // Nýtt fall til að athuga hvort valmyndaratriði ætti að vera sýnt
    const shouldShowMenuItem = (menuItem) => {
        return checkMenuItemConditions(menuItem, store);
    };

    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName) => {
        const path = window.location.pathname;
        if (routeName === '/') {
            return path === '/' ? 'active' : '';
        }
        if (path === routeName) {
            return 'active';
        }
        if (path.startsWith(routeName + '/')) {
            const nextChar = path.charAt(routeName.length);
            if (nextChar === '/') {
                return 'active';
            }
        }
        return '';
    };

    // Nýtt fall fyrir collapse parent sem styður bæði /groups og /group/:id
    const groupCollapseActive = () => {
        const path = window.location.pathname;
        return path === '/groups' || path.startsWith('/groups/') || path.startsWith('/group/');
    };

    // Generalized active check fyrir leaf links
    const generalizedActiveRoute = (routeName) => {
        const path = window.location.pathname;
        if (path === routeName) return 'active';
        // Ef routeName endar á 's', athugaðu hvort path byrji á routeName án 's' + '/'
        if (routeName.endsWith('s')) {
            const singular = routeName.slice(0, -1);
            if (path.startsWith(singular + '/') && path.length > singular.length + 1) {
                return 'active';
            }
        }
        return '';
    };

    // Sérhæft fall fyrir 'Hópurinn minn' leaf
    const myGroupActive = () => {
        const path = window.location.pathname;
        return path === '/groups' || path.startsWith('/group/');
    };

    const openCollapse = (collapse) => {
        setOpenAvatar(!openAvatar);
    };

    const createLinks = (routes) => {
        const itemText =
            classes.itemText +
            ' ' +
            cx({
                [classes.itemTextMini]: props.miniActive && miniActive,
                [classes.itemTextMiniRTL]: props.rtlActive && props.miniActive && miniActive,
                [classes.itemTextRTL]: props.rtlActive,
            });
        const collapseItemText =
            classes.collapseItemText +
            ' ' +
            cx({
                [classes.collapseItemTextMini]: props.miniActive && miniActive,
                [classes.collapseItemTextMiniRTL]:
                    props.rtlActive && props.miniActive && miniActive,
                [classes.collapseItemTextRTL]: props.rtlActive,
            });
        const isMini = props.miniActive && miniActive;
        const itemIcon =
            classes.itemIcon +
            ' ' +
            cx({ [classes.itemIconRTL]: props.rtlActive, [classes.itemIconMini]: isMini });
        const caret = classes.caret + ' ' + cx({ [classes.caretRTL]: props.rtlActive });
        const collapseItemMini =
            classes.collapseItemMini + ' ' + cx({ [classes.collapseItemMiniRTL]: props.rtlActive });

        return routes.map((prop, key) => {
            if (prop.redirect) {
                return null;
            }
            if (prop.permission && !prop.permission.some((r) => userPermission.includes(r))) {
                return null;
            }
            // Athuga dýnamískar skilyrði fyrir sýningu
            if (!shouldShowMenuItem(prop)) {
                return null;
            }

            if (prop.collapse && prop.state === 'groupsCollapse') {
                var st = _.mapValues(collapseState, () => false);
                st['userPermission'] = userPermission;
                st[prop['state']] = !collapseState[prop.state];

                const navLinkClasses =
                    classes.itemLink +
                    ' ' +
                    cx({
                        [' ' + classes.collapseActive]: groupCollapseActive(),
                        [classes.itemLinkMini]: isMini,
                    });

                return (
                    <ListItem
                        key={key}
                        className={cx(
                            { [classes.item]: prop.icon !== undefined },
                            { [classes.collapseItem]: prop.icon === undefined }
                        )}
                    >
                        <Tooltip title={isMini ? props.t(prop.name) : ''} placement="right" arrow>
                            <NavLink
                                to={'#'}
                                className={navLinkClasses}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setCollapseState(st);
                                }}
                            >
                                {prop.icon !== undefined ? (
                                    typeof prop.icon === 'string' ? (
                                        <Icon className={itemIcon}>{prop.icon}</Icon>
                                    ) : (
                                        <prop.icon className={itemIcon} />
                                    )
                                ) : (
                                    <span className={collapseItemMini}>
                                        {props.rtlActive ? prop.rtlMini : prop.mini}
                                    </span>
                                )}
                                <ListItemText
                                    primary={props.rtlActive ? prop.rtlName : props.t(prop.name)}
                                    secondary={
                                        <b
                                            className={
                                                caret +
                                                ' ' +
                                                (collapseState[prop.state]
                                                    ? classes.caretActive
                                                    : '')
                                            }
                                        />
                                    }
                                    disableTypography={true}
                                    className={cx(
                                        { [itemText]: prop.icon !== undefined },
                                        { [collapseItemText]: prop.icon === undefined }
                                    )}
                                />
                            </NavLink>
                        </Tooltip>
                        <Collapse in={collapseState[prop.state]} unmountOnExit>
                            <List className={classes.list + ' ' + classes.collapseList}>
                                {createLinks(prop.views)}
                            </List>
                        </Collapse>
                    </ListItem>
                );
            }
            if (prop.collapse) {
                var st = _.mapValues(collapseState, () => false);
                st['userPermission'] = userPermission;
                st[prop['state']] = !collapseState[prop.state];

                const navLinkClasses =
                    classes.itemLink +
                    ' ' +
                    cx({
                        [' ' + classes.collapseActive]: activeRoute(prop.path),
                        [classes.itemLinkMini]: isMini,
                    });

                return (
                    <ListItem
                        key={key}
                        className={cx(
                            { [classes.item]: prop.icon !== undefined },
                            { [classes.collapseItem]: prop.icon === undefined }
                        )}
                    >
                        <Tooltip title={isMini ? props.t(prop.name) : ''} placement="right" arrow>
                            <NavLink
                                to={'#'}
                                className={navLinkClasses}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setCollapseState(st);
                                }}
                            >
                                {prop.icon !== undefined ? (
                                    typeof prop.icon === 'string' ? (
                                        <Icon className={itemIcon}>{prop.icon}</Icon>
                                    ) : (
                                        <prop.icon className={itemIcon} />
                                    )
                                ) : (
                                    <span className={collapseItemMini}>
                                        {props.rtlActive ? prop.rtlMini : prop.mini}
                                    </span>
                                )}
                                <ListItemText
                                    primary={props.rtlActive ? prop.rtlName : props.t(prop.name)}
                                    secondary={
                                        <b
                                            className={
                                                caret +
                                                ' ' +
                                                (collapseState[prop.state]
                                                    ? classes.caretActive
                                                    : '')
                                            }
                                        />
                                    }
                                    disableTypography={true}
                                    className={cx(
                                        { [itemText]: prop.icon !== undefined },
                                        { [collapseItemText]: prop.icon === undefined }
                                    )}
                                />
                            </NavLink>
                        </Tooltip>
                        <Collapse in={collapseState[prop.state]} unmountOnExit>
                            <List className={classes.list + ' ' + classes.collapseList}>
                                {createLinks(prop.views)}
                            </List>
                        </Collapse>
                    </ListItem>
                );
            }
            const innerNavLinkClasses =
                classes.collapseItemLink +
                ' ' +
                cx({ [' ' + classes[color]]: generalizedActiveRoute(prop.path) });
            const navLinkClasses =
                classes.itemLink +
                ' ' +
                cx({
                    [' ' + classes[color]]: generalizedActiveRoute(prop.path),
                    [classes.itemLinkMini]: isMini,
                });

            if (prop.custom) {
                if (localStorage.getItem('user')) {
                    let userStore = JSON.parse(localStorage.getItem('user'));
                    let hasSpecialCompany = false;
                    userStore.companies &&
                        userStore.companies.map((item) => {
                            if (item.torgid_special_company_id === 4) {
                                hasSpecialCompany = true;
                            }
                        });
                    if (hasSpecialCompany) {
                        return (
                            <ListItem
                                key={key}
                                className={cx(
                                    { [classes.item]: prop.icon !== undefined },
                                    { [classes.collapseItem]: prop.icon === undefined }
                                )}
                            >
                                <Tooltip
                                    title={isMini ? props.t(prop.name) : ''}
                                    placement="right"
                                    arrow
                                >
                                    <NavLink
                                        to={prop.path}
                                        className={cx(
                                            { [navLinkClasses]: prop.icon !== undefined },
                                            { [innerNavLinkClasses]: prop.icon === undefined }
                                        )}
                                    >
                                        {prop.icon !== undefined ? (
                                            typeof prop.icon === 'string' ? (
                                                <Icon className={itemIcon}>{prop.icon}</Icon>
                                            ) : (
                                                <prop.icon className={itemIcon} />
                                            )
                                        ) : (
                                            <span className={collapseItemMini}>
                                                {props.rtlActive ? prop.rtlMini : prop.mini}
                                            </span>
                                        )}
                                        <ListItemText
                                            primary={
                                                props.rtlActive ? prop.rtlName : props.t(prop.name)
                                            }
                                            disableTypography={true}
                                            className={cx(
                                                { [itemText]: prop.icon !== undefined },
                                                { [collapseItemText]: prop.icon === undefined }
                                            )}
                                        />
                                    </NavLink>
                                </Tooltip>
                            </ListItem>
                        );
                    }
                }
            }

            if (prop.custom) {
                return null;
            }

            // Sérhæfð athugun fyrir 'Hópurinn minn' leaf
            if (prop.path === '/groups' && prop.name === 'menu.my_group') {
                const innerNavLinkClasses =
                    classes.collapseItemLink +
                    ' ' +
                    cx({ [' ' + classes[color]]: myGroupActive() });
                const navLinkClasses =
                    classes.itemLink + ' ' + cx({ [' ' + classes[color]]: myGroupActive() });
                return (
                    <ListItem
                        key={key}
                        className={cx(
                            { [classes.item]: prop.icon !== undefined },
                            { [classes.collapseItem]: prop.icon === undefined }
                        )}
                    >
                        <Tooltip title={isMini ? props.t(prop.name) : ''} placement="right" arrow>
                            <NavLink
                                to={prop.path}
                                className={cx(
                                    { [navLinkClasses]: prop.icon !== undefined },
                                    { [innerNavLinkClasses]: prop.icon === undefined }
                                )}
                            >
                                {prop.icon !== undefined ? (
                                    typeof prop.icon === 'string' ? (
                                        <Icon className={itemIcon}>{prop.icon}</Icon>
                                    ) : (
                                        <prop.icon className={itemIcon} />
                                    )
                                ) : (
                                    <span className={collapseItemMini}>
                                        {props.rtlActive ? prop.rtlMini : prop.mini}
                                    </span>
                                )}
                                <ListItemText
                                    primary={props.rtlActive ? prop.rtlName : props.t(prop.name)}
                                    disableTypography={true}
                                    className={cx(
                                        { [itemText]: prop.icon !== undefined },
                                        { [collapseItemText]: prop.icon === undefined }
                                    )}
                                />
                            </NavLink>
                        </Tooltip>
                    </ListItem>
                );
            }

            return (
                <ListItem
                    key={key}
                    className={cx(
                        { [classes.item]: prop.icon !== undefined },
                        { [classes.collapseItem]: prop.icon === undefined }
                    )}
                >
                    <Tooltip title={isMini ? props.t(prop.name) : ''} placement="right" arrow>
                        <NavLink
                            to={prop.path}
                            className={cx(
                                { [navLinkClasses]: prop.icon !== undefined },
                                { [innerNavLinkClasses]: prop.icon === undefined }
                            )}
                        >
                            {prop.icon !== undefined ? (
                                typeof prop.icon === 'string' ? (
                                    <Icon className={itemIcon}>{prop.icon}</Icon>
                                ) : (
                                    <prop.icon className={itemIcon} />
                                )
                            ) : (
                                <span className={collapseItemMini}>
                                    {props.rtlActive ? prop.rtlMini : prop.mini}
                                </span>
                            )}
                            <ListItemText
                                primary={props.rtlActive ? prop.rtlName : props.t(prop.name)}
                                disableTypography={true}
                                className={cx(
                                    { [itemText]: prop.icon !== undefined },
                                    { [collapseItemText]: prop.icon === undefined }
                                )}
                            />
                        </NavLink>
                    </Tooltip>
                </ListItem>
            );
        });
    };

    const itemText =
        classes.itemText +
        ' ' +
        cx({
            [classes.itemTextMini]: props.miniActive && miniActive,
            [classes.itemTextMiniRTL]: props.rtlActive && props.miniActive && miniActive,
            [classes.itemTextRTL]: props.rtlActive,
        });
    const collapseItemText =
        classes.collapseItemText +
        ' ' +
        cx({
            [classes.collapseItemTextMini]: props.miniActive && miniActive,
            [classes.collapseItemTextMiniRTL]: props.rtlActive && props.miniActive && miniActive,
            [classes.collapseItemTextRTL]: props.rtlActive,
        });
    const userWrapperClass = classes.user + ' ' + cx({ [classes.whiteAfter]: bgColor === 'white' });
    const caret = classes.caret + ' ' + cx({ [classes.caretRTL]: props.rtlActive });
    const collapseItemMini =
        classes.collapseItemMini + ' ' + cx({ [classes.collapseItemMiniRTL]: props.rtlActive });
    const photo = classes.photo + ' ' + cx({ [classes.photoRTL]: props.rtlActive });
    var user = null;
    var isCompanyUser = '';
    let userRole;
    let cLogo;
    let uRole;
    if (localStorage.getItem('user')) {
        try {
            user = JSON.parse(localStorage.getItem('user')).user;
            user.isprofile = true;
            isCompanyUser =
                user &&
                user.roles &&
                (user.roles.includes('company_user') || user.roles.includes('group_admin'));
            userRole = user && user.roles && user.roles[0];
            cLogo =
                user &&
                userRole &&
                userRole === 'company_user' &&
                user.companies.length === 1 &&
                user.companies[0].logo
                    ? user.companies[0].logo
                    : logo_mini;
            uRole = user && userRole && userRole === 'company_user';
        } catch (e) {
            Bugsnag.notify(e);
            clearLocalStoragePreservingPrefs();
            window.location = buildLoginPath();
        }
    }
    const logoItemStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1,
        minWidth: 0,
        cursor: 'default',
    };
    const logoLabelStyle = {
        fontSize: '9px',
        fontWeight: 600,
        color: 'var(--spara-sidebar-muted, #9a4558)',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        textAlign: 'center',
    };
    const logoNameStyle = {
        fontSize: '10px',
        fontWeight: 600,
        color: 'var(--spara-sidebar-fg, #de2c48)',
        textAlign: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
    };
    const dropdownItemStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '5px 8px',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '11px',
        fontWeight: 500,
        color: 'var(--spara-sidebar-fg, #de2c48)',
        transition: 'background 0.15s',
    };

    const hasCompanies = store.companies?.length > 0;
    const hasGroups = store.groups?.length > 0;

    const logosSection = (hasCompanies || hasGroups) && (
        <div
            style={{
                display: 'flex',
                alignItems: 'stretch',
                borderTop: '1px solid rgba(222,44,72,0.15)',
                borderBottom: '1px solid rgba(222,44,72,0.15)',
            }}
        >
            {hasGroups && (
                <div style={{ ...logoItemStyle, padding: '8px 16px 10px' }}>
                    <span style={logoLabelStyle}>Hópur</span>
                    {store.groups[0].logo && (
                        <img
                            src={store.groups[0].logo}
                            alt=""
                            onClick={() => navigate(`/group/${store.groups[0].id}`)}
                            style={{
                                width: '100%',
                                maxWidth: '120px',
                                aspectRatio: 1.7646768867,
                                objectFit: 'cover',
                                borderRadius: '10px',
                                border: '1px solid rgba(222,44,72,0.2)',
                                cursor: 'pointer',
                                background: '#fff',
                            }}
                        />
                    )}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '2px',
                            width: '100%',
                            justifyContent: 'center',
                        }}
                    >
                        <span style={logoNameStyle}>{store.groups[0].name}</span>
                        {store.groups.length > 1 && (
                            <ExpandMore
                                onClick={(e) => setGroupsAnchor(e.currentTarget)}
                                style={{
                                    fontSize: '14px',
                                    color: 'var(--spara-sidebar-fg, #de2c48)',
                                    cursor: 'pointer',
                                    flexShrink: 0,
                                    transform: groupsAnchor ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.2s',
                                }}
                            />
                        )}
                    </div>
                </div>
            )}
            {hasCompanies && hasGroups && (
                <div
                    style={{
                        width: '1px',
                        alignSelf: 'stretch',
                        background: 'rgba(222,44,72,0.2)',
                        flexShrink: 0,
                    }}
                />
            )}
            {hasCompanies && (
                <div style={{ ...logoItemStyle, padding: '8px 16px 10px' }}>
                    <span style={logoLabelStyle}>Fyrirtæki</span>
                    {store.companies[0].logo && (
                        <img
                            src={store.companies[0].logo}
                            alt=""
                            onClick={() => navigate(`/company/${store.companies[0].id}`)}
                            style={{
                                width: 'calc(100% / 1.7646768867)',
                                aspectRatio: '1',
                                objectFit: 'cover',
                                borderRadius: '50%',
                                border: '1px solid rgba(222,44,72,0.2)',
                                cursor: 'pointer',
                                background: '#fff',
                            }}
                        />
                    )}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '2px',
                            width: '100%',
                            justifyContent: 'center',
                        }}
                    >
                        <span style={logoNameStyle}>{store.companies[0].name}</span>
                        {store.companies.length > 1 && (
                            <ExpandMore
                                onClick={(e) => setCompaniesAnchor(e.currentTarget)}
                                style={{
                                    fontSize: '14px',
                                    color: 'var(--spara-sidebar-fg, #de2c48)',
                                    cursor: 'pointer',
                                    flexShrink: 0,
                                    transform: companiesAnchor ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.2s',
                                }}
                            />
                        )}
                    </div>
                </div>
            )}

            {/* Companies floating dropdown */}
            <Popover
                open={Boolean(companiesAnchor)}
                anchorEl={companiesAnchor}
                onClose={() => setCompaniesAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{
                    style: {
                        minWidth: '200px',
                        maxWidth: '280px',
                        borderRadius: '10px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                        border: '1px solid rgba(222,44,72,0.12)',
                        overflow: 'hidden',
                        padding: '6px',
                    },
                }}
            >
                {store.companies.slice(1).map((company) => (
                    <div
                        key={company.id}
                        style={dropdownItemStyle}
                        onClick={() => {
                            navigate(`/company/${company.id}`);
                            setCompaniesAnchor(null);
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.background = 'rgba(222,44,72,0.08)')
                        }
                        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                    >
                        {company.logo ? (
                            <img
                                src={company.logo}
                                alt=""
                                style={{
                                    width: '22px',
                                    height: '22px',
                                    borderRadius: '50%',
                                    objectFit: 'cover',
                                    flexShrink: 0,
                                }}
                            />
                        ) : (
                            <div
                                style={{
                                    width: '22px',
                                    height: '22px',
                                    borderRadius: '50%',
                                    background: 'rgba(222,44,72,0.1)',
                                    flexShrink: 0,
                                }}
                            />
                        )}
                        <span
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {company.name}
                        </span>
                    </div>
                ))}
            </Popover>

            {/* Groups floating dropdown */}
            <Popover
                open={Boolean(groupsAnchor)}
                anchorEl={groupsAnchor}
                onClose={() => setGroupsAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{
                    style: {
                        minWidth: '200px',
                        maxWidth: '280px',
                        borderRadius: '10px',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                        border: '1px solid rgba(222,44,72,0.12)',
                        overflow: 'hidden',
                        padding: '6px',
                    },
                }}
            >
                {(store.groups?.slice(1) || []).map((group) => (
                    <div
                        key={group.id}
                        style={dropdownItemStyle}
                        onClick={() => {
                            navigate(`/group/${group.id}`);
                            setGroupsAnchor(null);
                        }}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.background = 'rgba(222,44,72,0.08)')
                        }
                        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                    >
                        {group.logo ? (
                            <img
                                src={group.logo}
                                alt=""
                                style={{
                                    width: '32px',
                                    height: '18px',
                                    borderRadius: '4px',
                                    objectFit: 'cover',
                                    flexShrink: 0,
                                }}
                            />
                        ) : (
                            <div
                                style={{
                                    width: '32px',
                                    height: '18px',
                                    borderRadius: '4px',
                                    background: 'rgba(222,44,72,0.1)',
                                    flexShrink: 0,
                                }}
                            />
                        )}
                        <span
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {group.name}
                        </span>
                    </div>
                ))}
            </Popover>
        </div>
    );

    const miniLogosSection = (hasCompanies || hasGroups) && (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px',
                padding: '8px 0 10px',
                borderTop: '1px solid rgba(222,44,72,0.15)',
                borderBottom: '1px solid rgba(222,44,72,0.15)',
            }}
        >
            {hasCompanies && store.companies[0].logo && (
                <Tooltip
                    title={store.companies.map((c) => c.name).join(', ')}
                    placement="right"
                    arrow
                >
                    <img
                        src={store.companies[0].logo}
                        alt=""
                        onClick={() => navigate(`/company/${store.companies[0].id}`)}
                        style={{
                            width: '34px',
                            height: '34px',
                            objectFit: 'cover',
                            borderRadius: '50%',
                            border: '1px solid rgba(222,44,72,0.2)',
                            cursor: 'pointer',
                            background: '#fff',
                        }}
                    />
                </Tooltip>
            )}
            {hasGroups && store.groups[0].logo && (
                <Tooltip title={store.groups.map((g) => g.name).join(', ')} placement="right" arrow>
                    <img
                        src={store.groups[0].logo}
                        alt=""
                        onClick={() => navigate(`/group/${store.groups[0].id}`)}
                        style={{
                            width: '34px',
                            height: '20px',
                            objectFit: 'cover',
                            borderRadius: '4px',
                            border: '1px solid rgba(222,44,72,0.2)',
                            cursor: 'pointer',
                            background: '#fff',
                        }}
                    />
                </Tooltip>
            )}
        </div>
    );

    var miniUserWrap = (
        <div className={userWrapperClass}>
            <Tooltip
                title={liveUserData?.results?.name ?? (user && user.torgid_user.name)}
                placement="right"
                arrow
            >
                <Link
                    to="/profile"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '8px 0',
                        borderTop: '1px solid rgba(222,44,72,0.18)',
                        textDecoration: 'none',
                        transition: 'background-color 300ms linear',
                    }}
                    onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.3)')
                    }
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '')}
                >
                    <div
                        style={{
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                            border: '2px solid rgba(222,44,72,0.25)',
                            flexShrink: 0,
                        }}
                    >
                        <img
                            src={
                                liveUserData?.results?.profile_picture
                                    ? liveUserData.results.profile_picture
                                    : user && user.torgid_user && user.torgid_user.profile_picture
                                    ? user.torgid_user.profile_picture
                                    : avatar
                            }
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            alt="..."
                        />
                    </div>
                </Link>
            </Tooltip>
            {miniLogosSection}
        </div>
    );

    var userWrap = (
        <div
            className={`${userWrapperClass} ${styles.profileUserWrapper}`}
            style={{ margin: 0, paddingBottom: 0 }}
        >
            <Link to="/profile" className={styles.profileLink}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '6px 14px 6px 10px',
                        cursor: 'pointer',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            flexShrink: 0,
                            width: '44px',
                            height: '44px',
                            borderRadius: '50%',
                            overflow: 'hidden',
                            border: '1px solid rgba(222,44,72,0.25)',
                        }}
                    >
                        <img
                            src={
                                liveUserData?.results?.profile_picture
                                    ? liveUserData.results.profile_picture
                                    : user && user.torgid_user && user.torgid_user.profile_picture
                                    ? user.torgid_user.profile_picture
                                    : avatar
                            }
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            alt="..."
                        />
                    </div>
                    <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                        <div
                            style={{
                                fontWeight: 600,
                                fontSize: '13px',
                                color: 'var(--spara-sidebar-fg, #de2c48)',
                                lineHeight: 1.3,
                                overflow: 'hidden',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                            }}
                        >
                            {liveUserData?.results?.name ?? (user && user.torgid_user.name)}
                        </div>
                        <div
                            style={{
                                fontSize: '11px',
                                color: 'var(--spara-sidebar-muted, #9a4558)',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {(() => {
                                const tu = liveUserData?.results ?? (user && user.torgid_user);
                                if (!tu) return null;
                                if (tu.kennitala)
                                    return tu.kennitala.replace(/^(\d{6})(\d{4})$/, '$1-$2');
                                if (tu.phone) return tu.phone;
                                return tu.email;
                            })()}
                        </div>
                        {hasCompanies && !store.companies[0].logo && (
                            <div
                                style={{
                                    fontSize: '11px',
                                    color: 'var(--spara-sidebar-muted, #9a4558)',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {store.companies[0].name}
                            </div>
                        )}
                        {hasGroups && !store.groups[0].logo && (
                            <div
                                style={{
                                    fontSize: '11px',
                                    color: 'var(--spara-sidebar-muted, #9a4558)',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {store.groups[0].name}
                            </div>
                        )}
                    </div>
                    <ChevronRight
                        style={{
                            color: 'var(--spara-sidebar-fg, #de2c48)',
                            fontSize: '18px',
                            flexShrink: 0,
                        }}
                    />
                </div>
            </Link>
            {logosSection}
        </div>
    );
    var links = (
        <List
            className={
                classes.list + (props.miniActive && miniActive ? ' ' + classes.listMini : '')
            }
        >
            {createLinks(routes)}
        </List>
    );

    var sidebarActions = (
        <div
            style={{
                position: 'relative',
                zIndex: 9999,
                padding: '6px 12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 8,
                borderTop: '1px solid var(--spara-border-subtle, rgba(222,44,72,0.15))',
                flexWrap: 'wrap',
            }}
        >
            <LanguageSwitcher size="sm" />
            <ThemeToggle size="sm" />
            <LogoutButton size="sm" showText onBeforeLogout={onLogoutStart} />
        </div>
    );

    const logoNormal =
        classes.logoNormal +
        ' ' +
        cx({
            [classes.logoNormalSidebarMini]: props.miniActive && miniActive,
            [classes.logoNormalSidebarMiniRTL]: props.rtlActive && props.miniActive && miniActive,
            [classes.logoNormalRTL]: props.rtlActive,
        });
    const logoClasses = classes.logo + ' ' + cx({ [classes.whiteAfter]: bgColor === 'white' });
    var brand = (
        <div className={logoClasses} style={miniActive ? { paddingTop: '36px' } : {}}>
            <Link to="/" className={logoNormal}>
                {miniActive ? (
                    <span
                        translate="no"
                        style={{
                            display: 'block',
                            textAlign: 'center',
                            fontSize: '1.1rem',
                            fontStyle: 'italic',
                            fontWeight: 700,
                            color: 'var(--spara-primary, #de2c48)',
                            lineHeight: '36px',
                        }}
                    >
                        Spara
                    </span>
                ) : (
                    <span style={{ display: 'block', textAlign: 'center', textTransform: 'none' }}>
                        <span
                            translate="no"
                            style={{
                                display: 'block',
                                fontSize: '2rem',
                                fontStyle: 'italic',
                                fontWeight: 700,
                                color: 'var(--spara-primary, #de2c48)',
                                lineHeight: 1,
                            }}
                        >
                            Spara
                        </span>
                        <span
                            style={{
                                display: 'block',
                                fontSize: '0.75rem',
                                fontStyle: 'italic',
                                fontWeight: 500,
                                color: 'var(--spara-primary, #de2c48)',
                            }}
                        >
                            {props.t('for_admins')}
                        </span>
                    </span>
                )}
            </Link>
        </div>
    );
    const drawerPaper =
        classes.drawerPaper +
        ' ' +
        cx({
            [classes.drawerPaperMini]: props.miniActive && miniActive,
            [classes.drawerPaperRTL]: props.rtlActive,
        });
    const drawerPaperAnimated =
        drawerPaper + ' ' + (loggingOut ? styles.sidebarSlideOut : styles.sidebarSlideIn);
    const sidebarWrapper =
        classes.sidebarWrapper +
        ' ' +
        cx({
            [classes.drawerPaperMini]: props.miniActive && miniActive,
            [classes.sidebarWrapperWithPerfectScrollbar]: navigator.platform.indexOf('Win') > -1,
        });

    const collapseToggle = sidebarMinimize ? (
        <Tooltip title={miniActive ? 'Stækka hliðarslá' : 'Minnka hliðarslá'} placement="right">
            <button
                onClick={sidebarMinimize}
                style={{
                    position: 'absolute',
                    top: '8px',
                    ...(miniActive
                        ? { left: '50%', transform: 'translateX(-50%)' }
                        : { left: '8px' }),
                    zIndex: 9999,
                    background: 'transparent',
                    border: '1px solid transparent',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(222,44,72,0.12)')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            >
                {miniActive ? (
                    <ChevronRight style={{ color: '#de2c48', width: '18px', height: '18px' }} />
                ) : (
                    <ChevronLeft style={{ color: '#de2c48', width: '18px', height: '18px' }} />
                )}
            </button>
        </Tooltip>
    ) : null;

    return (
        <div ref={mainPanel}>
            <Hidden smUp implementation="css">
                <Drawer
                    variant="temporary"
                    anchor={props.rtlActive ? 'right' : 'left'}
                    open={props.open}
                    classes={{
                        paper: drawerPaper + ' ' + classes[bgColor + 'Background'],
                    }}
                    onClose={props.handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    <div style={{ position: 'relative' }}>
                        {brand}
                        <button
                            onClick={props.handleDrawerToggle}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: '12px',
                                transform: 'translateY(-50%)',
                                zIndex: 10,
                                background: 'rgba(222,44,72,0.08)',
                                border: '1px solid rgba(222,44,72,0.2)',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                padding: '6px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Close style={{ color: '#de2c48', width: '20px', height: '20px' }} />
                        </button>
                    </div>
                    <SidebarWrapper className={sidebarWrapper} user={userWrap} links={links} />
                    <div className={classes.background} />
                    {sidebarActions}
                </Drawer>
            </Hidden>
            <Drawer
                anchor={props.rtlActive ? 'right' : 'left'}
                variant="permanent"
                open
                sx={{ display: { xs: 'none', sm: 'block' } }}
                classes={{
                    paper: drawerPaperAnimated + ' ' + classes[bgColor + 'Background'],
                }}
                PaperProps={
                    loggingOut
                        ? {
                              style: {
                                  animation: 'sparaSlideOutLeft 0.4s ease-in forwards',
                                  pointerEvents: 'none',
                              },
                          }
                        : undefined
                }
            >
                {brand}
                {collapseToggle}
                <SidebarWrapper
                    className={sidebarWrapper}
                    user={miniActive ? miniUserWrap : userWrap}
                    links={links}
                />
                <div className={classes.background} />
                {!miniActive && (
                    <p
                        style={{
                            zIndex: 9999,
                            textAlign: 'center',
                            color: '#de2c48',
                            margin: '0',
                            padding: '0 0 8px',
                        }}
                    >
                        &copy; {1900 + new Date().getYear()}
                        {' — '}
                        <span style={{ fontWeight: 600, fontStyle: 'italic', fontSize: '15px' }}>
                            Spara ehf.
                        </span>
                    </p>
                )}
            </Drawer>
        </div>
    );
};

export default withTranslation('', { withRef: true })(SideBar);
